import { EncryptJWT, jwtDecrypt } from 'jose';

// Kunci rahasia (pastikan panjangnya minimal 32 karakter untuk AES-256)
// Catatan: Di frontend, kunci ini tetap bisa dilihat jika seseorang inspect kode, 
// tetapi ini mencegah pembacaan langsung secara kasat mata di localStorage.
const SECRET_KEY = new TextEncoder().encode('a7d2974576bb0eee94fba9858eb40152');
//Key MD5 = e-sea.kkp.go.id

/**
 * Enkripsi data objek/string menjadi JWE Token string
 */
export async function encryptData(payloadData) {
  try {
    const jwt = await new EncryptJWT({ data: payloadData })
      .setProtectedHeader({ alg: 'dir', enc: 'A256GCM' }) // Menggunakan Direct encryption dengan AES-256-GCM
      .setIssuedAt()
      .setExpirationTime('7d') // Atur masa berlaku data terenkripsi jika perlu
      .encrypt(SECRET_KEY);
    
    return jwt;
  } catch (error) {
    console.error('Gagal mengenkripsi data:', error);
    return null;
  }
}

/**
 * Dekripsi JWE Token kembali ke data asli
 */
export async function decryptData(cipherText) {
  try {
    const { payload } = await jwtDecrypt(cipherText, SECRET_KEY);
    return payload.data; // Mengembalikan data asli yang tersimpan di dalam payload
  } catch (error) {
    console.error('Gagal mendeskripsi data (mungkin token rusak atau kunci salah):', error);
    return null;
  }
}